/**
 * Maps a route to the FAQ module (key in public/locales/<lng>/faq.json -> "modules")
 * that documents it. First match wins, so list specific prefixes before broad ones.
 * Add a line here when a new module gets FAQs.
 */
const ROUTE_PREFIXES: Array<[prefix: string, module: string]> = [
  // Specific routes that live under another module's prefix
  ["/members", "members"],
  ["/staff/class-requests", "classes"],
  ["/finance/items/classes", "classes"],
  ["/finance/items/zones", "operations"],
  ["/finance/items", "pos"],
  ["/pos/stock", "inventory"],
  ["/settings/plans", "memberships"],
  ["/settings/promotions", "memberships"],
  ["/settings/dynamic-pricing", "memberships"],
  ["/settings/referral-program", "memberships"],
  ["/settings/groups", "memberships"],
  ["/settings/corporate", "memberships"],
  ["/settings/organizations", "memberships"],
  ["/settings/pt-session-types", "memberships"],
  ["/settings/member-document-visibility", "memberships"],
  ["/settings/crm", "leads"],
  ["/settings/trial-templates", "leads"],
  ["/settings/class-", "classes"],
  ["/settings/exercise-swaps", "training"],
  ["/settings/assessment-template", "training"],
  ["/settings/pt-reassign", "staff"],
  ["/settings/finance/pt-commission", "hr"],
  ["/settings/finance/discount-limits", "pos"],
  ["/settings/stores", "pos"],
  ["/settings/payment-gateways", "pos"],
  ["/settings/printer-config", "pos"],
  ["/settings/accounting", "pos"],
  ["/settings/suppliers", "inventory"],
  ["/settings/access-", "checkin"],
  ["/settings/devices", "checkin"],
  ["/settings/kiosk-devices", "checkin"],
  ["/settings/ops", "operations"],
  ["/settings/self-registration", "operations"],
  ["/settings/notification", "marketing"],
  ["/settings/nps", "marketing"],
  ["/settings/digest", "marketing"],
  ["/analytics/access", "checkin"],

  // Module roots
  ["/check-in", "checkin"],
  ["/access-qr", "checkin"],
  ["/kiosk", "checkin"],
  ["/memberships", "memberships"],
  ["/plans", "memberships"],
  ["/subscriptions", "memberships"],
  ["/retention", "memberships"],
  ["/billing", "memberships"],
  ["/corporate", "memberships"],
  ["/referrals", "memberships"],
  ["/gamification", "memberships"],
  ["/leads", "leads"],
  ["/trial", "leads"],
  ["/classes", "classes"],
  ["/programs", "training"],
  ["/workouts", "training"],
  ["/exercises", "training"],
  ["/diet-plans", "training"],
  ["/nutrition", "nutrition"],
  ["/staff", "staff"],
  ["/trainers", "staff"],
  ["/trainer", "staff"],
  ["/clock", "staff"],
  ["/timesheets", "staff"],
  ["/pt", "staff"],
  ["/payroll", "hr"],
  ["/leave", "hr"],
  ["/pos", "pos"],
  ["/sales", "pos"],
  ["/payments", "pos"],
  ["/cashbook", "pos"],
  ["/wallet", "pos"],
  ["/inventory", "inventory"],
  ["/ops", "operations"],
  ["/maintenance", "operations"],
  ["/marketing", "marketing"],
  ["/notifications", "marketing"],
  ["/nps", "marketing"],
  ["/reports", "reports"],
  ["/analytics", "reports"],
  ["/settings", "settings"],
  ["/account", "settings"],
  ["/login", "settings"],
];

export function faqModuleForPath(pathname: string): string | null {
  if (pathname === "/" || pathname === "/dashboard") return "dashboard";
  for (const [prefix, module] of ROUTE_PREFIXES) {
    // Prefixes ending in "-" or a letter-run are partial-segment matches (e.g. "/settings/class-").
    if (prefix.endsWith("-") ? pathname.startsWith(prefix) : pathname === prefix || pathname.startsWith(`${prefix}/`)) {
      return module;
    }
  }
  return null;
}
